export default __webpack_public_path__ + "static/media/tournaments_1.1159ead2.svg";